import React from "react";

interface DetailsCardProps {
  className?: string;
  title: string;
  value: any;
}

interface CardDataProps {
  cardData: DetailsCardProps[];
  handleClick?: (data: any) => void;
}
const EventEHRSimpleCard = ({ cardData, handleClick }: CardDataProps) => {
  return (
    <>
      {cardData?.map((data, index: number) => (
        <div
          key={index}
          className="border-1px-solid-D2D2D2 border-radius-8px px-5  py-3 flex gap-2 flex-col w-full justify-between"
          onClick={() => {
            handleClick && handleClick(data);
          }}
        >
          <div
            className={`${data.className || "font-weight-400 font-size-16px color-565656"}`}
          >
            {data?.title}
          </div>
          <div className="font-weight-500 text-2xl color-393939">
            {data?.value}
          </div>
        </div>
      ))}
    </>
  );
};

export default EventEHRSimpleCard;
